import { Mask, Spinner, Text } from '@instructure/ui';

export const PageLoader = (options) => {
  return (
    <Mask placement="center" fullscreen={true} themeOverride={{ zIndex: 9999 }}>
      <Spinner renderTitle={options.text} size="large" />
      <Text size="large" color="primary">
        {options.text}
      </Text>
    </Mask>
  );
};

export default PageLoader;
